module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Rec-42405e9667727cb9bb3b774aea9ec582.svg";